import React from "react";
import appStyles from "../../App.module.scss";
import GlobalContext from "../../contexts/GlobalContext";

const Overlay = () => {
  const globalContext = React.useContext(GlobalContext);
  return (
    <div
      onClick={() => {
        globalContext.closeOverlay();
        globalContext.setFitmentSideBar("ClOSED");
      }}
      className={
        globalContext.isAccountOpen ||
        globalContext.fitmentSideBarState !== "ClOSED" ||
        globalContext.isDepartmentsOpen ||
        globalContext.isMobileFiltersOpen
          ? appStyles.overlay
          : ""
      }
    />
  );
};

export default Overlay;
